export default "__VITE_ASSET__u1s5WYuK__"